import script from "./BlogItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogItem.vue?vue&type=script&setup=true&lang=js"

import "./BlogItem.vue?vue&type=style&index=0&id=62a17296&lang=css"
import "./BlogItem.vue?vue&type=style&index=1&id=62a17296&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a17296"]])

export default __exports__